import { apiUrl } from './tool'
import axios from 'axios'
import { CRM_PERMISSIONS, ALL_PERMISSION_CODES } from '@/constants/permissions'

const useMock = false // 開發階段使用 mock，後端完成後改為 false

/**
 * 取得所有可用的權限列表
 * GET /api/permissions
 */
export function getPermissionsAPI() {
  if (useMock) {
    return Promise.resolve({
      data: {
        permissions: CRM_PERMISSIONS.map((p, index) => ({
          id: index + 1,
          name: p.name,
          code_name: p.code_name
        }))
      }
    })
  }

  const url = apiUrl('crm-permissions')
  return axios.get(url)
}

/**
 * Mock 用戶資料（用於開發測試）
 */
const mockUsers = [
  {
    id: 1,
    type: 1,
    clinic_code: '0000000002',
    doctor_code: null,
    name: '主權限',
    account: 'admin',
    email: 'admin@dentco.tw',
    is_root: true,
    is_active: true,
    route_permissions: ALL_PERMISSION_CODES // 主權限擁有所有權限
  },
  {
    id: 2,
    type: 1,
    clinic_code: '0000000002',
    doctor_code: null,
    name: '助理A',
    account: '0912345678',
    email: 'assistant@dentco.tw',
    is_root: false,
    is_active: true,
    route_permissions: ['home', 'patients', 'onlineReserve'] // 部分權限
  },
  {
    id: 3,
    type: 1,
    clinic_code: '0000000002',
    doctor_code: null,
    name: '助理B',
    account: '0987654321',
    email: 'assistant2@dentco.tw',
    is_root: false,
    is_active: true,
    route_permissions: ['home', 'message', 'upload'] // 部分權限
  }
]

/**
 * 取得帳號列表
 * GET /api/users
 */
export function getUsersAPI(params = {}) {
  if (useMock) {
    return Promise.resolve({
      data: {
        users: mockUsers
      }
    })
  }

  const url = apiUrl('users')
  return axios.get(url, { params })
}

/**
 * 新增帳號
 * POST /api/users
 */
export function createUserAPI(data) {
  if (useMock) {
    const newUser = {
      id: mockUsers.length + 1,
      type: 1,
      clinic_code: '0000000002',
      doctor_code: null,
      name: data.name,
      account: data.account,
      email: data.email,
      is_root: false,
      is_active: true,
      route_permissions: data.route_permissions || []
    }

    // 檢查帳號是否重複
    if (mockUsers.some(u => u.account === data.account)) {
      return Promise.reject({
        response: {
          data: {
            code: 'ACCOUNT_DUPLICATE',
            message: '此帳號已存在，請更換帳號'
          }
        }
      })
    }

    mockUsers.push(newUser)
    return Promise.resolve({ data: { user: newUser } })
  }

  const url = apiUrl('users')
  return axios.post(url, data)
}

/**
 * 編輯帳密
 * PUT /api/users/:id
 */
export function updateUserCredentialsAPI(userId, data) {
  if (useMock) {
    const userIndex = mockUsers.findIndex(u => u.id === userId)
    if (userIndex === -1) {
      return Promise.reject({ response: { data: { message: '帳號不存在' } } })
    }

    mockUsers[userIndex] = {
      ...mockUsers[userIndex],
      name: data.name,
      email: data.email
      // password 不在前端儲存
    }

    return Promise.resolve({ data: { user: mockUsers[userIndex] } })
  }

  const url = apiUrl('users', userId)
  return axios.put(url, data)
}

/**
 * 編輯權限
 * PUT /api/users/:id/permissions
 */
export function updateUserPermissionsAPI(userId, data) {
  if (useMock) {
    const userIndex = mockUsers.findIndex(u => u.id === userId)
    if (userIndex === -1) {
      return Promise.reject({ response: { data: { message: '帳號不存在' } } })
    }

    // 檢查是否為主權限帳號
    if (mockUsers[userIndex].is_root) {
      return Promise.reject({
        response: {
          data: {
            code: 'CANNOT_EDIT_ROOT_PERMISSION',
            message: '主權限帳號無法編輯權限'
          }
        }
      })
    }

    mockUsers[userIndex].routePermissions = data.route_permissions

    return Promise.resolve({ data: { user: mockUsers[userIndex] } })
  }

  const url = apiUrl('users', userId, 'permissions')
  return axios.put(url, data)
}

/**
 * 刪除帳號
 * DELETE /api/users/:id
 */
export function deleteUserAPI(userId, params) {
  if (useMock) {
    const userIndex = mockUsers.findIndex(u => u.id === userId)
    if (userIndex === -1) {
      return Promise.reject({ response: { data: { message: '帳號不存在' } } })
    }

    // 檢查是否為主權限帳號
    if (mockUsers[userIndex].is_root) {
      return Promise.reject({
        response: {
          data: {
            code: 'CANNOT_DELETE_ROOT',
            message: '主權限帳號無法刪除'
          }
        }
      })
    }

    mockUsers.splice(userIndex, 1)
    return Promise.resolve({ data: { success: true } })
  }

  const url = apiUrl('users', userId)
  return axios.delete(url, { params })
}
